/**
 * Local mirror of packages/shared/src/validation.ts — kept as a copy so the
 * widget bundle never imports the shared index (which would pull zod into the
 * public bundle). Keep in sync with the shared version; the API enforces the
 * same rules server-side, so drift here only affects error UX, not security.
 */

export function isValidPhone(raw: string): boolean {
  const cleaned = raw.replace(/[\s\-().]/g, "");
  const digits = cleaned.startsWith("+") ? cleaned.slice(1) : cleaned;
  if (!/^\d{7,15}$/.test(digits)) return false;
  return !/^(\d)\1*$/.test(digits);
}

export function isBlockedEmailDomain(email: string, blocked: string[] | undefined | null): boolean {
  if (!blocked?.length) return false;
  const domain = email.toLowerCase().split("@")[1]?.trim();
  if (!domain) return false;
  return blocked.some((entry) => {
    const b = entry.toLowerCase().trim();
    return b !== "" && (domain === b || domain.endsWith("." + b));
  });
}
